import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link, useNavigate, useLocation } from "react-router-dom";
import MetaTags from "../MetaTags";
import { useDispatch, useSelector } from "react-redux";
import { setMenu, setScrollStatus } from "./headerSlice";
import {
  getHeader,
  getSearchApi,
  gettitledataAPI,
} from "../../../services/routes.services";
import HeaderStyle from "../../Style/Header.module.css";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { FaLinkedinIn } from "react-icons/fa";
import { FiSearch } from "react-icons/fi";
import classNames from "classnames";
import { IoMdClose } from "react-icons/io";
import { HiOutlineMenu } from "react-icons/hi";
import { FaCaretDown } from "react-icons/fa";
import constants from "../../../services/constants";
import he from "he";
import TQlogo from "../../../assest/images/TQCert_TATA_logo.svg";
const Header = () => {
  const dispatch = useDispatch();
  const { menu, isScrolled } = useSelector((state) => state.header);
  const [searchBox, setSearchBox] = useState(false);
  const [wondowlScroll, setWindowScroll] = useState(false);
  const [query, setQuery] = useState("");
  const [searchResults, setSearchResults] = useState({});
  const [isActive, setIsActive] = useState(false);
  const [isActiveSubMenu, setIsActiveSubMenu] = useState(false);
  const [isActiveMegaMenu, setIsActiveMegaMenu] = useState(false);
  const [pageData, setPageData] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const ToggleMenu = () => {
    setIsActive(!isActive);
  };
  const subMenuHandler = (item) => {
    if (
      item.children &&
      Array.isArray(item.children) &&
      item.children.length > 0
    ) {
      if (item.megaMenu === "on") {
        // Toggle mega menu and close regular submenu if open
        setIsActiveSubMenu(false);
        setIsActiveMegaMenu(!isActiveMegaMenu);
      } else {
        // Toggle regular submenu and close mega menu if open
        setIsActiveMegaMenu(false);
        setIsActiveSubMenu(!isActiveSubMenu);
      }
    }
  };

  const SubMenu = ({ subItems }) => {
    const sortedSubItems = [...subItems].sort(
      (a, b) => a.orderNumber - b.orderNumber,
    );

    return (
      <ul
        className={
          `child-element ${isActiveSubMenu ? HeaderStyle.active : ""}` +
          " " +
          HeaderStyle.subMenu
        }
      >
        {sortedSubItems.map((subItem, index) => (
          <li key={index}>
            <Link to={subItem.linkUrl} title={subItem.linkText}>
              {subItem.linkText}
            </Link>
          </li>
        ))}
      </ul>
    );
  };

  const MegaMenu = ({ subItems }) => {
    const sortedSubItems = [...subItems].sort(
      (a, b) => a.orderNumber - b.orderNumber,
    );
    return (
      <div
        className={
          `megaMenuStyle child-element ${
            isActiveMegaMenu ? HeaderStyle.active : ""
          }` +
          " " +
          HeaderStyle.megaMenu
        }
      >
        <Tabs className={HeaderStyle.tabContainer}>
          <div className={HeaderStyle.leftArea}>
            <TabList className="offTabStyle">
              {sortedSubItems.map((subItem, index) => (
                <Tab key={index}>{subItem.linkText}</Tab>
              ))}
            </TabList>
          </div>
          <div className={HeaderStyle.RightArea}>
            {sortedSubItems.map((subItem, index) => (
              <TabPanel key={index}>
                <ul className={HeaderStyle.megaLink}>
                  {/* {subItem.children
                    .slice() // Create a new array
                    .sort((a, b) => a.orderNumber - b.orderNumber)
                    .map((item, index) => {
                      return (
                        <>
                          {item.linkText !== "Wearhousing" && item.linkText !== "SHE Services" && item.linkText !== "Technical Services" && (
                            <li key={index}>
                              <Link to={item.linkUrl} title={item.linkText}>
                                {item.linkText}
                              </Link>
                            </li>
                          )}
                        </>
                      );
                    })} */}
                  {subItem.children
                    .slice()
                    .sort((a, b) => a.orderNumber - b.orderNumber)
                    .map((item) => {
                      if (
                        item.linkText === "Wearhousing" ||
                        item.linkText === "SHE Services" ||
                        item.linkText === "Technical Services"
                      ) {
                        return null;
                      }

                      return (
                        <li
                          key={
                            item._id ||
                            item.id ||
                            item.orderNumber ||
                            item.linkUrl
                          }
                        >
                          <Link to={item.linkUrl} title={item.linkText}>
                            {item.linkText}
                          </Link>
                        </li>
                      );
                    })}
                </ul>
              </TabPanel>
            ))}
          </div>
        </Tabs>
      </div>
    );
  };
  const handleSearch = async () => {
    try {
      if (query !== "") {
        const response = await getSearchApi(query);
        setSearchResults(response.data);
        navigate(`/search?query=${query}`, {
          state: { searchResults: response.data },
        });
      } else {
        alert("Please enter value");
      }
    } catch (err) {
      console.error(err);
    }
  };
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };
  const SearchHandler = () => {
    setSearchBox(true);
  };
  const CloseSearchHandler = () => {
    setSearchBox(false);
  };
  const fetchdata = async () => {
    try {
      const currentUrl = location.pathname;

      if (!currentUrl || currentUrl === "/") return;

      console.log("Current URL:", currentUrl);

      const response = await gettitledataAPI(currentUrl);
      setPageData(response.data.header);
      // console.log("Page Data:", response.data.header);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  useEffect(() => {
    fetchdata();
  }, [location.pathname]);
  useEffect(() => {
    window.addEventListener("scroll", () => {
      setWindowScroll(window.scrollY > 100);
    });
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      dispatch(setScrollStatus(window.scrollY > 300));
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [dispatch]);

  useEffect(() => {
    getHeader()
      .then((res) => {
        dispatch(setMenu(res.data.headers));
      })
      .catch((error) => {
        console.error("Failed to fetch header data", error);
      });
  }, [dispatch]);

  if (!menu || menu.length === 0) {
    return null;
  }

  const sortedMenu = [...menu].sort((a, b) => a.orderNumber - b.orderNumber);

  return (
    <>
      <MetaTags
        title={
          pageData?.field_meta_title
            ? pageData?.field_meta_title
            : pageData?.linkText
        }
        description={
          pageData?.field_meta_description
            ? pageData?.field_meta_description
            : pageData?.linkText
        }
        keywords={
          pageData?.field_meta_keywords
            ? pageData?.field_meta_keywords
            : pageData?.pageData?.linkText
        }
        canonicalUrl={pageData?.field_canonical_url ?? undefined}
        ogType={pageData?.field_og_type ?? "website"}
        ogTitle={pageData?.field_og_title ?? pageData?.title}
        ogDescription={pageData?.field_og_description ?? undefined}
        ogUrl={pageData?.field_og_url ?? undefined}
        ogImage={
          pageData?.field_og_image_url
            ? `${constants.Image_BASE_URL}${pageData.field_og_image_url}`
            : undefined
        }
        schema={pageData?.field_og_scheema_code ?? undefined}
      />
      <header
        className={wondowlScroll ? `fixHeader ${HeaderStyle.fixed}` : null}
      >
        <Container>
          <Row>
            <Col>
              <div className={HeaderStyle.headerFlex}>
                <div className={HeaderStyle.Logo}>
                  <Link to="/" title="TQcert">
                    <img
                      alt="TQcert Logo"
                      src={TQlogo}
                      width="89"
                      height="52"
                    />
                  </Link>
                </div>
                <div
                  className={
                    `child-element ${isActive ? HeaderStyle.active : ""}` +
                    " " +
                    HeaderStyle.Menu
                  }
                >
                  <button
                    type="button"
                    className={HeaderStyle.closeMenu}
                    onClick={ToggleMenu}
                  >
                    <IoMdClose />{" "}
                  </button>
                  <ul>
                    {sortedMenu.map((item) => (
                      <li key={item.orderNumber}>
                        <Link to={item.linkUrl} title={item.linkText}>
                          {item.linkText}
                        </Link>
                        {item.children &&
                          Array.isArray(item.children) &&
                          item.children.length > 0 && (
                            <button
                              type="button"
                              onClick={() => {
                                subMenuHandler(item);
                              }}
                              className={HeaderStyle.subMenuIcon}
                            >
                              <FaCaretDown />
                            </button>
                          )}
                        {item.children &&
                          Array.isArray(item.children) &&
                          item.children.length > 0 &&
                          (item.megaMenu === "on" ? (
                            <MegaMenu subItems={item.children} />
                          ) : (
                            <SubMenu subItems={item.children} />
                          ))}
                      </li>
                    ))}
                  </ul>
                </div>

                <div
                  className={HeaderStyle.SocialIcon}
                  // style={{ display: "none" }}
                >
                  <ul>
                    <li className={HeaderStyle.ToggleMenu}>
                      <button type="button" onClick={ToggleMenu}>
                        <HiOutlineMenu />
                      </button>
                    </li>

                    <li className={HeaderStyle.tataLogo}>
                      <a
                        href="https://www.tata.com/"
                        target="_blank"
                        title="Tata"
                      >
                        <svg
                          width="48px"
                          height="41px"
                          viewBox="0 0 228 200"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                        >
                          <g
                            id="Page-1"
                            stroke="none"
                            strokeWidth="1"
                            fill="none"
                            fillRule="evenodd"
                          >
                            <g
                              id="2D-stacked"
                              transform="translate(-1.000000, 0.000000)"
                              fill="#2364ab"
                            >
                              <g
                                id="Tata-Logo"
                                transform="translate(1.000000, 0.000000)"
                              >
                                <polyline
                                  id="Fill-1"
                                  points="0.123 142.563 54.864 142.563 54.864 159.219 39.163 159.219 39.163 199.255 16.352 199.255 16.352 159.219 0.123 159.219 0.123 142.563"
                                ></polyline>
                                <polyline
                                  id="Fill-2"
                                  points="82.587 165.469 71.065 199.255 49.157 199.255 70.643 142.563 94.429 142.563 116.43 199.255 94.259 199.255 82.587 165.469"
                                ></polyline>
                                <polyline
                                  id="Fill-3"
                                  points="111.201 142.563 165.941 142.563 165.941 159.219 150.241 159.219 150.241 199.255 127.43 199.255 127.43 159.219 111.201 159.219 111.201 142.563"
                                ></polyline>
                                <polyline
                                  id="Fill-4"
                                  points="193.666 165.469 182.142 199.255 160.235 199.255 181.721 142.563 205.507 142.563 227.509 199.255 205.338 199.255 193.666 165.469"
                                ></polyline>
                                <path
                                  d="M194.093,38.504 C192.058,34.502 189.37,30.662 186.037,27.064 C178.543,18.973 167.966,12.242 155.448,7.598 C142.835,2.919 128.439,0.446 113.816,0.446 C99.193,0.446 84.797,2.919 72.185,7.598 C59.666,12.242 49.088,18.973 41.594,27.064 C38.261,30.663 35.572,34.505 33.536,38.509 C49.828,34.57 77.699,29.365 103.578,28.818 C106.075,28.765 107.793,29.563 108.925,30.996 C110.305,32.743 110.199,38.973 110.163,41.756 L109.426,113.748 C110.886,113.797 112.35,113.829 113.816,113.829 C115.294,113.829 116.764,113.803 118.223,113.753 L117.487,41.756 C117.45,38.973 117.345,32.743 118.725,30.996 C119.857,29.563 121.574,28.765 124.071,28.818 C149.939,29.365 177.798,34.567 194.093,38.504"
                                  id="Fill-5"
                                ></path>
                                <path
                                  d="M197.567,47.864 C173.72,42.473 157.798,41.477 142.082,40.605 C128.387,39.846 128.21,44.736 129.579,54.083 C129.662,54.653 129.774,55.371 129.906,56.192 C134.499,83.402 140.218,106.819 141.203,110.788 C174.596,103.16 198.679,81.997 198.679,57.137 C198.679,54.008 198.297,50.908 197.567,47.864"
                                  id="Fill-6"
                                ></path>
                                <path
                                  d="M98.071,54.083 C99.439,44.736 99.263,39.846 85.568,40.605 C69.847,41.477 53.92,42.474 30.064,47.868 C29.335,50.911 28.953,54.009 28.953,57.137 C28.953,67.883 33.324,78.282 41.594,87.212 C49.088,95.302 59.666,102.033 72.185,106.677 C76.721,108.36 81.5,109.735 86.426,110.833 C87.352,107.11 93.205,83.204 97.853,55.508 C97.936,54.975 98.012,54.487 98.071,54.083"
                                  id="Fill-7"
                                ></path>
                              </g>
                            </g>
                          </g>
                        </svg>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </header>
    </>
  );
};

export default Header;
